export function ScheduleUtilizationLegend() {
  return (
    <div className="flex items-center gap-3 text-xs text-muted-foreground px-3 py-1.5">
      <span className="font-medium">Utilization:</span>
      <span className="flex items-center gap-1">
        <span className="inline-block w-3 h-2 rounded-sm bg-green-500" />
        Under 90%
      </span>
      <span className="flex items-center gap-1">
        <span className="inline-block w-3 h-2 rounded-sm bg-yellow-500" />
        90–100%
      </span>
      <span className="flex items-center gap-1">
        <span className="inline-block w-3 h-2 rounded-sm bg-red-500" />
        Over capacity
      </span>
    </div>
  );
}
